import { jbColors } from 'theme/jbColors';

const MuiFormLabel = {
  styleOverrides: {
    root: {
      color: jbColors.support.greenSmoke[100],
      '&&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
};

export default MuiFormLabel;
